import './styles/styles.scss';
import { useContext, useEffect } from 'react';
import { Switch, Route, HashRouter, useHistory, Link } from 'react-router-dom';
import ProfilePage from './pages/profile';
import ResultsPage from './pages/results';
import HomePage from './pages/home';
import { IAppContext } from './context/DefaultAppState';
import { AppContext } from './context/AppContext';
import initializeApp from './lib/initialization';
import axios from 'axios';
import { config } from 'dotenv';
import { NotFound } from './pages/notFound';
import TherapeuticSubClassList from './components/TherapeuticSubClassList/TherapeuticSubClassList';
import PlanSelectionPage from './pages/planSelection';
import styles from './components/TherapeuticSubClassList/TherapeuticSubClassList.module.scss';
import { ArrowLeft } from './icons/icons';
import { IPlan } from './interfaces/IPlan';

// config({
//   path: `.env.${process.env.REACT_APP_ENV}`
// });

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

const App = () => {
  const appContext = useContext(AppContext);
  const history = useHistory();
  useEffect(() => initialize(appContext), []);

  return (
    <div className="app-padding">
      <div className="header-container">
        <h1>Prescription Drug List</h1>
        { appContext.plan ?
          <div>
            {/* { appContext.plan.formularyDisclaimerLink ? 
              <>
              <a className="disclaimer-link" href={appContext.plan.formularyDisclaimerLink} target="_blank" rel="noreferrer">
                {new Date().getFullYear()} {appContext.plan.planName} Formulary Introduction (Preamble)
              </a>
              <br/>
              </> : null
            }
            { appContext.plan.formularyDisclaimerLink2 ? 
              <>
              <a className="disclaimer-link" href={appContext.plan.formularyDisclaimerLink2} target="_blank" rel="noreferrer">
                {new Date().getFullYear() + 1} {appContext.plan.planName} Formulary Introduction (Preamble)
              </a>
              <br/>
              </> : null
            } */}
            <a onClick={() => { appContext.updatePlan(null) ; history.push('/')}} className="select-plan-link">
              <span>Select a Different Plan or State</span>
            </a>
          </div>
          : <hr/>}
      </div>
      <div className="body-container">
        <HashRouter>
          <Switch>
            {appContext.plan ? (
              <>
              <Route path="/plan-selection" exact component={PlanSelectionPage} />
              <Route path="/profile/:tier/:drugId" component={ProfilePage} />
              <Route path="/results/:tier/:drugName/:resultsQueryType" component={ResultsPage} />
              <Route path="/therapeutic/:tier/:therapeuticCategory" component={TherapeuticSubClassList} />
              <Route path="/" exact component={HomePage} />
              </>
              ) : null}
            {!appContext.plan || !appContext.planState ? <Route path="/" component={PlanSelectionPage} /> : null}
            <Route component={NotFound} />
          </Switch>
        </HashRouter>
      </div>
    </div>
  );
};

const initialize = (appContext: IAppContext) => {
  (async () => {
    await initializeApp(appContext);
  })();
};

export default App;
